export default __webpack_public_path__ + "static/media/alert.ca776106.svg";